import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addTestimonials, deleteTestimonials, fetchTestimonials, fetchTestimonialsPublic, updateTestimonials } from "./TestimonialsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchTestimonialsAsync = createAsyncThunk(
  "Testimonials/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchTestimonials();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchTestimonialsPublicAsync = createAsyncThunk(
  "TestimonialsPublic/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchTestimonialsPublic();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteTestimonialsAsync = createAsyncThunk(
  'Testimonials/delete',
  async ({uuid}, { rejectWithValue }) => {
    try {
      await deleteTestimonials(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTestimonialsAsync = createAsyncThunk(
  'Testimonials/update',
  async ({ uuid, testimonialsData }, { rejectWithValue }) => {
    try {
      const response = await updateTestimonials(uuid, testimonialsData);
      console.log("Response Slice testi", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addTestimonialsAsync = createAsyncThunk(
  "Testimonials/add",
  async ({newTestimonials}) => {
    try {
      const data = await addTestimonials(newTestimonials);
      console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const TestimonialsSlice = createSlice({
  name: "Testimonials",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonialsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestimonialsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchTestimonialsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchTestimonialsPublicAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestimonialsPublicAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchTestimonialsPublicAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addTestimonialsAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addTestimonialsAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateTestimonialsAsync.pending, (state) => {
        state.loading = true;
        // console.log("Loading")
        state.error = null;
      })
      .addCase(updateTestimonialsAsync.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("data", state.data)
        state.data = state.data.map((testimonialsData) =>
          testimonialsData.uuid === action.payload.uuid ? action.payload : testimonialsData
        );
      })
      .addCase(updateTestimonialsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteTestimonialsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTestimonialsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (cityData) => cityData.id !== action.payload
        );
      })
      .addCase(deleteTestimonialsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectTestimonials = (state) => state.testimonials.data;

export default TestimonialsSlice.reducer;
